import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpResponse } from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HomepageService } from './homepage.service';

import { environment } from '../../environments/environment';
import { CookieService  } from 'ngx-cookie-service';
import { AuthService } from './auth.service';
import { TenantService } from './tenant.service';
@Injectable({
  providedIn: 'root'
})
export class SearchService {
	tetent: string = '';
  confiGurationSetting: string = '*';
  locationId: any = '*';
  recentSearch: string = '';
  recentCount: number = 0;
    constructor(private http: HttpClient, private homepageService: HomepageService, private cookieService: CookieService, private authService: AuthService, private tenantService: TenantService) {

    this.tetent = this.tenantService.tenant;
    this.confiGurationSetting = this.tenantService.configurationSetting;

    this.locationId = this.homepageService.getLocationId();    
  }
  	private readonly apiUrl = environment.apiUrl;


  	basicSearch(limitArray, term, srcin,resourceSID, exact, size,order, exploreId?) : Observable<any> {
      var limitString: string = '';
      for (var key in limitArray) {
        limitString += '&'+ key +'='+ limitArray[key];
      }
      var auth: any = 'null';
      //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
         var auth: any =  'Bearer '+localStorage.getItem('token');
         //'Authorization': auth
      } 
      this.locationId = this.homepageService.getLocationId();
     	let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary': this.locationId,'tenant': this.tetent, 'configuration' : this.confiGurationSetting,'Authorization': auth });
      if(resourceSID != '' &&  typeof(resourceSID) != 'undefined'){
        return this.http.get(this.apiUrl+'search/fieldValue?id='+resourceSID+'&size='+size+'&order='+order ,{ headers: headers, observe:'response' })
          .pipe(
              map((response: HttpResponse<any>) => {
                this.setLastSearch('search/fieldValue?id='+resourceSID+'&size='+size+'&order='+order);
                if(response.headers.get('Session-Id')){
                  this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
                }
                return response.body;
              }),
              catchError((error) => this.handleError(error))
            );
      } else {
        if(term != ''){
          if(exploreId){
            exploreId = "&exp-btn-id=" +
                exploreId
          }else{
            exploreId = ''
          }
          return this.http.get(this.apiUrl+'search/base?size='+size+'&term='+term+'&in='+srcin+'&exact='+exact+limitString+'&order='+order +exploreId ,{ headers: headers, observe:'response' })
        	.pipe(
          		map((response: HttpResponse<any>) => {
                this.setLastSearch('search/base?size='+size+'&term='+term+'&in='+srcin+'&exact='+exact+limitString+'&order='+order +exploreId);
                if(response.headers.get('Session-Id')){
                  this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
                }
                return response.body;
              }),
              catchError((error) => this.handleError(error))
            );
        }
      }
   }

   basicMarc(limitArray, term, srcin,exact, size, order, exploreId) : Observable<any> {
    this.locationId = this.homepageService.getLocationId();
    var limitString: string = '';
    for (var key in limitArray) {
      limitString += '&'+ key +'='+ limitArray[key];
    }
    //console.log(limitString);
    var auth: any = 'null';
      //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
         var auth: any =  'Bearer '+localStorage.getItem('token');
         //,'Authorization': auth
      } 
      if(exploreId){
        exploreId = "&exp-btn-id=" +
            exploreId
      }else{
        exploreId = ''
      }
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary': this.locationId,'tenant': this.tetent, 'configuration' : this.confiGurationSetting,'Authorization': auth });
      return this.http.get(this.apiUrl+'search/marc?size='+size+'&term='+term+'&in='+srcin+'&exact='+exact+limitString+'&order='+order +exploreId ,{ headers: headers, observe:'response' })
          .pipe(
              map((response: HttpResponse<any>) => {
                this.setLastSearch('search/marc?size='+size+'&term='+term+'&in='+srcin+'&exact='+exact+limitString+'&order='+order);
                if(response.headers.get('Session-Id')){
                  this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
                }
                return response.body;
              }),
              catchError((error) => this.handleError(error))
            );
   }

   basicCall(limitArray, callStart, callEnd,exact, listSize, order, exploreId?) : Observable<any> {
    this.locationId = this.homepageService.getLocationId();
    var limitString: string = '';
    for (var key in limitArray) {
      limitString += '&'+ key +'='+ limitArray[key];
    }
    var auth: any = 'null';
      //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
         var auth: any =  'Bearer '+localStorage.getItem('token');
         //,'Authorization': auth
      } 
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary': this.locationId,'tenant': this.tetent, 'configuration' : this.confiGurationSetting,'Authorization': auth });
      if(exploreId){
        exploreId = "&exp-btn-id=" +
            exploreId
      }else{
        exploreId = ''
      }
      return this.http.get(this.apiUrl+'search/call?start='+callStart+'&end='+callEnd+'&size='+listSize+'&exact=false'+limitString+'&order='+order+exploreId ,{ headers: headers, observe:'response' })
          .pipe(
              map((response: HttpResponse<any>) => {
                this.setLastSearch('search/call?start='+callStart+'&end='+callEnd+'&size='+listSize+'&exact=false'+limitString+'&order='+order);
                if(response.headers.get('Session-Id')){
                  this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
                }
                return response.body;
              }),
              catchError((error) => this.handleError(error))
            );
  }

  basicCategory(limitArray, categoryId, exact, listSize, order, exploreId?): Observable<any> {
    this.locationId = this.homepageService.getLocationId();
    var limitString: string = '';
    for (var key in limitArray) {
      limitString += '&' + key + '=' + limitArray[key];
    }
    var auth: any = 'null';
    //if (this.cookieService.check('info')) {
    if (localStorage.getItem('info') != null){
      var auth: any = 'Bearer ' + localStorage.getItem('token');
      //,'Authorization': auth
    }
    let headers = new HttpHeaders({ 'app-id': 'opac', 'selectedlibrary': this.locationId, 'tenant': this.tetent, 'configuration': this.confiGurationSetting, 'Authorization': auth });
    if(exploreId){
      exploreId = "&exp-btn-id=" +
          exploreId
    }else{
      exploreId = ''
    }
    return this.http.get(this.apiUrl + 'search/Category?categoryId=' + categoryId + '&size=' + listSize + '&exact=false' + limitString + '&order=' + order + exploreId, { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          this.setLastSearch('search/Category?categoryId=' + categoryId + '&size=' + listSize + '&exact=false' + limitString + '&order=' + order);
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

   basicBarcode(limitArray, callStart, callEnd,exact, listSize, order, exploreId?) : Observable<any> {
    this.locationId = this.homepageService.getLocationId();
    var limitString: string = '';
    for (var key in limitArray) {
      limitString += '&'+ key +'='+ limitArray[key];
    }
      var auth: any = 'null';
      //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
         var auth: any =  'Bearer '+localStorage.getItem('token');
         //,'Authorization': auth
      }
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary': this.locationId,'tenant': this.tetent, 'configuration' : this.confiGurationSetting,'Authorization': auth });
      if(exploreId){
        exploreId = "&exp-btn-id=" +
            exploreId
      }else{
        exploreId = ''
      }
      return this.http.get(this.apiUrl+'search/barcode?start='+callStart+'&end='+callEnd+'&size='+listSize+'&exact='+exact+limitString+'&order='+order+exploreId ,{ headers: headers, observe:'response' })
          .pipe(
            map((response: HttpResponse<any>) => {
              this.setLastSearch('search/barcode?start='+callStart+'&end='+callEnd+'&size='+listSize+'&exact='+exact+limitString+'&order='+order);
              if(response.headers.get('Session-Id')){
                this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
              }
              return response.body;
            }),
            catchError((error) => this.handleError(error))
          );
   }

   basicReadingCounts(limitArray, levelmin, levelmax, pointmin, pointmax, exact, listSize, order, exploreId?) : Observable<any> {
    this.locationId = this.homepageService.getLocationId();
    var limitString: string = '';
    for (var key in limitArray) {
      limitString += '&'+ key +'='+ limitArray[key];
    }
    var auth: any = 'null';
      //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
         var auth: any =  'Bearer '+localStorage.getItem('token');
         //,'Authorization': auth
      }
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary': this.locationId,'tenant': this.tetent, 'configuration' : this.confiGurationSetting,'Authorization': auth });
      if(exploreId){
        exploreId = "&exp-btn-id=" +
            exploreId
      }else{
        exploreId = ''
      }
      return this.http.get(this.apiUrl+'search/rc?levelmin='+levelmin+'&levelmax='+levelmax+'&pointmin='+pointmin+'&pointmax='+pointmax+'&size='+listSize+'&exact='+exact+limitString+'&order='+order+exploreId ,{ headers: headers, observe:'response' })
          .pipe(
            map((response: HttpResponse<any>) => {
              this.setLastSearch('search/rc?levelmin='+levelmin+'&levelmax='+levelmax+'&pointmin='+pointmin+'&pointmax='+pointmax+'&size='+listSize+'&exact='+exact+limitString+'&order='+order);
              if(response.headers.get('Session-Id')){
                this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
              }
              return response.body;
            }),
            catchError((error) => this.handleError(error))
          );
  }

  basicFountas(limitArray, levelmin, levelmax, exact, listSize, order, exploreId?): Observable<any> {
    this.locationId = this.homepageService.getLocationId();
    var limitString: string = '';
    for (var key in limitArray) {
      limitString += '&' + key + '=' + limitArray[key];
    }
    var auth: any = 'null';
    //if (this.cookieService.check('info')) {
    if (localStorage.getItem('info') != null){
      var auth: any = 'Bearer ' + localStorage.getItem('token');
      //,'Authorization': auth
    }
    let headers = new HttpHeaders({ 'app-id': 'opac', 'selectedlibrary': this.locationId, 'tenant': this.tetent, 'configuration': this.confiGurationSetting, 'Authorization': auth });
    if(exploreId){
      exploreId = "&exp-btn-id=" +
          exploreId
    }else{
      exploreId = ''
    }
    return this.http.get(this.apiUrl + 'search/fp?levelmin=' + levelmin + '&levelmax=' + levelmax + '&size=' + listSize + '&exact=' + exact + limitString + '&order=' + order + exploreId, { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          this.setLastSearch('search/fp?levelmin=' + levelmin + '&levelmax=' + levelmax + '&size=' + listSize + '&exact=' + exact + limitString + '&order=' + order);
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }
   
   acceleratedReader(limitArray, levelmin, levelmax, pointmin, pointmax, Arlevel, listSize, order, exploreId?) : Observable<any> {
    this.locationId = this.homepageService.getLocationId();
    var limitString: string = '';
    for (var key in limitArray) {
      limitString += '&'+ key +'='+ limitArray[key];
    }
      var auth: any = 'null';
      //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
         var auth: any =  'Bearer '+localStorage.getItem('token');
         //,'Authorization': auth
      }
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary': this.locationId,'tenant': this.tetent, 'configuration' : this.confiGurationSetting,'Authorization': auth });
      if(exploreId){
        exploreId = "&exp-btn-id=" +
            exploreId
      }else{
        exploreId = ''
      }
      return this.http.get(this.apiUrl+'search/ar?size='+listSize+'&levelmin='+levelmin+'&levelmax='+levelmax+'&pointmin='+pointmin+'&pointmax='+pointmax+'&int='+Arlevel+limitString+'&order='+order+exploreId ,{ headers: headers, observe:'response' })
          .pipe(
            map((response: HttpResponse<any>) => {
              this.setLastSearch('search/ar?size='+listSize+'&levelmin='+levelmin+'&levelmax='+levelmax+'&pointmin='+pointmin+'&pointmax='+pointmax+'&int='+Arlevel+limitString+'&order='+order);
              if(response.headers.get('Session-Id')){
                this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
              }
              return response.body;
            }),
            catchError((error) => this.handleError(error))
          );
   }

   Lexile(limitArray, levelmin, levelmax, pointmin, pointmax, listSize, order, exploreId?) : Observable<any> {
    this.locationId = this.homepageService.getLocationId();
    var limitString: string = '';
    for (var key in limitArray) {
      limitString += '&'+ key +'='+ limitArray[key];
    }
    var auth: any = 'null';
      //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
         var auth: any =  'Bearer '+localStorage.getItem('token');
         //,'Authorization': auth
      }
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary': this.locationId,'tenant': this.tetent, 'configuration' : this.confiGurationSetting,'Authorization': auth });
      if(exploreId){
        exploreId = "&exp-btn-id=" +
            exploreId
      }else{
        exploreId = ''
      }
      return this.http.get(this.apiUrl+'search/lexile?size='+listSize+'&levelmin='+levelmin+'&levelmax='+levelmax+'&code='+pointmin+'&patronType='+pointmax+limitString+'&order='+order+exploreId ,{ headers: headers, observe:'response' })
          .pipe(
            map((response: HttpResponse<any>) => {
              this.setLastSearch('search/lexile?size='+listSize+'&levelmin='+levelmin+'&levelmax='+levelmax+'&code='+pointmin+'&patronType='+pointmax+limitString+'&order='+order);
              if(response.headers.get('Session-Id')){
                this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
              }
              return response.body;
            }),
            catchError((error) => this.handleError(error))
          );
   }

   booleanSearch(limitArray, parameters, listSize, order, exploreId?) : Observable<any> {
    this.locationId = this.homepageService.getLocationId();
    var limitString: string = '';
    for (var key in limitArray) {
      limitString += '&'+ key +'='+ limitArray[key];
    }
    var auth: any = 'null';
      //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
         var auth: any =  'Bearer '+localStorage.getItem('token');
         //,'Authorization': auth
      }
      if(exploreId){
        exploreId = "&exp-btn-id=" +
            exploreId
      }else{
        exploreId = ''
      }
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary': this.locationId,'tenant': this.tetent, 'configuration' : this.confiGurationSetting,'Authorization': auth });
      return this.http.get(this.apiUrl+'search/bool?'+'size='+listSize+'&'+parameters+limitString+'&order='+order+exploreId ,{ headers: headers, observe:'response' })
          .pipe(
              map((response: HttpResponse<any>) => {
               this.setLastSearch('search/bool?'+'size='+listSize+'&'+parameters+limitString+'&order='+order+exploreId);
               if(response.headers.get('Session-Id')){
                this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
              }
              return response.body;
            }),
              catchError((error) => this.handleError(error))
            );
   }

   popularandnewSearchSearch(period, psize,publish, order, auth) : Observable<any> {
    this.locationId = this.homepageService.getLocationId();

      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary': this.locationId,'tenant': this.tetent, 'configuration' : this.confiGurationSetting,'Authorization':'Bearer '+auth });
      return this.http.get(this.apiUrl+'search/popular?age='+period+'&publish='+publish+'&size='+psize+'&order='+order ,{ headers: headers, observe:'response' })
          .pipe(
              map((response: HttpResponse<any>) => {
               this.setLastSearch('search/popular?age='+period+'&publish='+publish+'&size='+psize+'&order='+order+'&desc=false');
               if(response.headers.get('Session-Id')){
                this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
              }
              return response.body;
            }),
              catchError((error) => this.handleError(error))
            );
   }

   newInLibrarySearchSearch(period,copies,ppublish,size, order, auth) : Observable<any> {
    this.locationId = this.homepageService.getLocationId();
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary': this.locationId,'tenant': this.tetent, 'configuration' : this.confiGurationSetting,'Authorization':'Bearer '+auth });
      return this.http.get(this.apiUrl+'search/new?count='+period+'&newcopies='+copies+'&publish='+ppublish+'&order='+order+'&desc=false'+'&size='+size ,{ headers: headers, observe:'response' })
          .pipe(
              map((response: HttpResponse<any>) => {
               this.setLastSearch('search/new?age='+period+'&copies='+copies+'&publish='+ppublish+'&size='+size+'&order'+order+'&desc=false');
               if(response.headers.get('Session-Id')){
                this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
              }
              return response.body;
            }),
              catchError((error) => this.handleError(error))
            );
   }

    getResourceSearchData(resourceId,listSize){
      this.locationId = this.homepageService.getLocationId();
      var auth: any = 'null';
      //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
         var auth: any =  'Bearer '+localStorage.getItem('token');
         //,'Authorization': auth
      }
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary': this.locationId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Authorization': auth});
       return this.http.get(this.apiUrl+'search/fieldValue?id='+resourceId+'&size='+listSize+'&offset=0',{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
    } 

   getExploreSearchData(url, size){
    this.locationId = this.homepageService.getLocationId();
    var auth: any = 'null';
      //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
         var auth: any =  'Bearer '+localStorage.getItem('token');
         //,'Authorization': auth
      }
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary': this.locationId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Authorization': auth});
       return this.http.get(this.apiUrl+'search/'+url+'&size='+size,{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
    }

   getResourceList(Id,size,sortBy, exploreId){
    this.locationId = this.homepageService.getLocationId();
    var auth: any = 'null';
      //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
         var auth: any =  'Bearer '+localStorage.getItem('token');
         //,'Authorization': auth
      }
      if(exploreId){
        exploreId = "&exp-btn-id=" +
            exploreId
      }else{
        exploreId = ''
      }
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary': this.locationId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Authorization': auth});
       return this.http.get(this.apiUrl+'resource/list/'+Id+'?size='+size+'&order='+sortBy+exploreId,{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
    }

    getSeriesSearchData(isbn,series,alltitles,size){
    this.locationId = this.homepageService.getLocationId();
    var auth: any = 'null';
      //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
         var auth: any =  'Bearer '+localStorage.getItem('token');
         //,'Authorization': auth
      }
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary': this.locationId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Authorization': auth});
       return this.http.get(this.apiUrl+'search/series/?isbn='+isbn+'&series='+series+'&alltitles='+alltitles+'&size='+size,{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
    }

   getRecentSearch(RecentURL){
    this.locationId = this.homepageService.getLocationId();
    var auth: any = 'null';
      //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
         var auth: any =  'Bearer '+localStorage.getItem('token');
         //,'Authorization': auth
      }
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary': this.locationId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Authorization': auth});
       return this.http.get(this.apiUrl+RecentURL,{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
    }


    setLastSearch(url){
      this.recentSearch = url;
    }
    getLastSearch(){
       return this.recentSearch;
    }


    getReviewSearch(reviewstatus,starrating, review_age, location, reviewer, reviewCategories, exploreId? ){
       var auth: any = 'null';
      //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
         var auth: any =  'Bearer '+localStorage.getItem('token');
         //,'Authorization': auth
      }
      if(exploreId){
        exploreId = "&exp-btn-id=" +
            exploreId
      }else{
        exploreId = ''
      }
      let headers = new HttpHeaders({'app-id' : 'opac','selectedlibrary': this.locationId,'tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Content-Type' : 'application/json','Authorization': auth});
       return this.http.post(this.apiUrl+'review/search?offset=0&size=9999'+exploreId,{ 
          "cacheKey": null,
          "publishStatus": reviewstatus,
          "minimumStar": starrating,
          "reviewAge": review_age,
          "categories": reviewCategories,
          "reviewer": reviewer,
          "offSet": 0,
          "size": 9999
        },{ headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
    }

    sortedImage(images){
      //console.log('Sorted=='+images);
      var sources = ['OL','GB','MR','PQ','CM'];
      var sizes = ['xxs','xs','s','m','l','xl'];
      var imagesAll = [];
      sources.forEach((src)=>{
        sizes.forEach((evt) => {
          images.forEach((img) => {
           // console.log('=='+img);
            if(img.size == evt && img.source == src){
              imagesAll.push(img.url);
            }
          });
        });
      });
      return imagesAll;
    }

    public handleError(error: any) {
      if (error.status == 401) {
          this.authService.logoutSubject.next(true);
        return EMPTY;
      } else {
        return throwError(error);
      }
    }
}
